// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { akEditorUnitZIndex, relativeFontSizeToBase16 } from '@atlaskit/editor-shared-styles';
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace
import * as colors from '@atlaskit/theme/colors';
import { B300, N400 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export var header = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  zIndex: akEditorUnitZIndex,
  minHeight: "var(--ds-space-300, 24px)",
  padding: "var(--ds-space-250, 20px)".concat(" ", "var(--ds-space-500, 40px)"),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxShadow: "'none'",
  font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  color: "var(--ds-text, ".concat(colors.N400, ")"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  backgroundColor: "var(--ds-background-neutral-subtle, ".concat(colors.N0, ")"),
  borderRadius: "var(--ds-radius-small, 3px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export var footer = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  zIndex: akEditorUnitZIndex,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  color: "var(--ds-text-subtlest, ".concat(colors.N300, ")"),
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  padding: "var(--ds-space-300, 24px)",
  textAlign: 'right',
  boxShadow: "'none'"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export var footerNew = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  zIndex: akEditorUnitZIndex,
  color: "var(--ds-text-subtle, #505258)",
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  padding: "var(--ds-space-300, 24px)",
  textAlign: 'right',
  boxShadow: "'none'"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var contentWrapper = css({
  padding: "var(--ds-space-250, 20px)".concat(" ", "var(--ds-space-500, 40px)"),
  borderBottomRightRadius: "var(--ds-radius-small, 3px)",
  overflow: 'auto',
  position: 'relative',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  color: "var(--ds-text-subtle, ".concat(colors.N400, ")"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  backgroundColor: "var(--ds-background-neutral-subtle, ".concat(colors.N0, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var line = css({
  background: "var(--ds-background-neutral-subtle, #fff)",
  content: "''",
  display: 'block',
  height: "var(--ds-space-025, 2px)",
  left: 0,
  position: 'absolute',
  top: 0,
  right: 0,
  width: '100%',
  minWidth: '604px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var content = css({
  minWidth: '524px',
  width: '100%',
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between'
});
export var column = {
  width: '44%',
  '& > ul': {
    padding: 0
  }
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var row = css({
  margin: "var(--ds-space-250, 20px)".concat(" 0"),
  display: 'flex',
  justifyContent: 'space-between'
});
export var dialogHeader = {
  '&': {
    fontSize: relativeFontSizeToBase16(24),
    fontWeight: "var(--ds-font-weight-regular, 400)",
    color: "var(--ds-text-subtle, ".concat(N400, ")"),
    letterSpacing: 'normal',
    lineHeight: 1.42857142857143
  }
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var shortcutsArray = css({
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
  gap: "var(--ds-space-150, 12px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var componentFromKeymapWrapperStyles = css({
  flexShrink: 0
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var toolbarButton = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
  '&:focus:not(:focus-visible)': {
    outline: "2px solid ".concat("var(--ds-border-focused, ".concat(B300, ")")),
    outlineOffset: "var(--ds-space-025, 2px)"
  }
});